var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-10" },
    [
      _c("TabsWithRoutes", {
        staticClass: "mb-0.5",
        attrs: {
          routeTabs: _vm.routeTabs,
          navClass: "navParent",
          variant: "yellow",
        },
        scopedSlots: _vm._u(
          [
            {
              key: _vm.routes.ALL_ACTIVE_CLIENTS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [
                    _vm._v("Active profiles"),
                  ]),
                  _vm.activeTotal
                    ? _c("TabNotificationBubble", {
                        attrs: {
                          notification: _vm.activeTotal,
                          gray: "",
                          medium: true,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.ALL_COMPLETED_CLIENTS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [
                    _vm._v("Closed profiles"),
                  ]),
                  _vm.closedTotal
                    ? _c("TabNotificationBubble", {
                        attrs: {
                          notification: _vm.closedTotal,
                          gray: "",
                          medium: true,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: _vm.routes.ALL_DRAFT_CLIENTS,
              fn: function () {
                return [
                  _c("span", { staticClass: "mr-1" }, [
                    _vm._v("Draft profiles"),
                  ]),
                  _vm.draftTotal
                    ? _c("TabNotificationBubble", {
                        attrs: {
                          notification: _vm.draftTotal,
                          gray: "",
                          medium: true,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _vm.dialog
        ? _c("ProjectModal", {
            attrs: { companyId: _vm.company.id, currentUser: _vm.currentUser },
            on: {
              close: function ($event) {
                _vm.dialog = false
              },
            },
          })
        : _vm._e(),
      _c("router-view", {
        attrs: {
          company: _vm.company,
          currentUser: _vm.currentUser,
          totalClient: _vm.totalClient,
          activeTotal: _vm.activeTotal,
          draftTotal: _vm.draftTotal,
          closedTotal: _vm.closedTotal,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }